import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './ClubSelector.css';

export default function ClubSelector() {
  const [selectedClub, setSelectedClub] = useState('');
  const [revealedCode, setRevealedCode] = useState('');
  const [copied, setCopied] = useState(false);
  const cardRefs = useScrollReveal(1);

  const handleClubChange = (e) => {
    const club = e.target.value;
    setSelectedClub(club);
    setCopied(false);
    
    const clubCodes = {
      FVSL: 'FVSL2026',
      HAL: 'HAL2026',
      ICSF: 'ICSF2026',
      PSA: 'PSA2026',
      PMSC: 'PMSC2026',
      TSA: 'TSA2026',
      TSSFC: 'TSSFC2026',
      VOLF: 'Volf2026',
      WVFC: 'WVFC2026'
    };
    
    const code = clubCodes[club] || 'FVSL2026';
    setRevealedCode(code);
    if (window.applyClubCodeFromSelector) {
      window.applyClubCodeFromSelector(code);
    }
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(revealedCode);
    setCopied(true);
    if (window.applyClubCodeFromSelector) {
      window.applyClubCodeFromSelector(revealedCode);
    }
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <section className="club-selector-section" id="club-partners">
      <div className="container select-you-container text-center">
        <h2 className="club-selector-title">SELECT YOUR CLUB</h2>
        <p className="club-selector-subtitle">Choose your club to reveal your exclusive discount code</p>
        
        <div 
          className="select-wrapper-homepage"
          ref={(el) => (cardRefs.current[0] = el)}
        >
          <select 
            onChange={handleClubChange} 
            className="club-select-dropdown-homepage"
            value={selectedClub}
            aria-label="Select your club, league or academy for exclusive discount code"
          >
            <option value="" disabled>Select your club, league or academy below.</option>
            <option value="FVSL">Fraser Valley Soccer League</option>
            <option value="HAL">Horizon Academy League</option>
            <option value="ICSF">ICSF Columbus FC</option>
            <option value="PSA">Premier Soccer Academy</option>
            <option value="PMSC">Port Moody Soccer Club</option>
            <option value="TSA">Total Soccer Academy</option>
            <option value="TSSFC">TSS Rovers FC</option>
            <option value="VOLF">Volf Soccer Academy</option>
            <option value="WVFC">West Vancouver FC</option>
          </select>
          <span className="select-arrow-homepage"></span>
        </div>
        
        {selectedClub && (
          <div className="club-reveal-banner-homepage animate-fade-in">
            <div className="banner-details">
              <span className="reveal-text">
                Your Exclusive Discount Code: <strong>{revealedCode}</strong>
              </span>
            </div>
            <div className="banner-actions">
              <button 
                type="button" 
                onClick={handleCopyCode}
                className="btn btn-outline reveal-btn-copy"
              >
                {copied ? 'Copied & Applied ✓' : 'Copy Code'}
              </button>
              <button 
                type="button"
                onClick={() => {
                  if (window.applyClubCodeFromSelector) {
                    window.applyClubCodeFromSelector(revealedCode);
                  }
                  const shopSection = document.getElementById('product-showcase');
                  if (shopSection) {
                    shopSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn btn-volt reveal-btn-shop"
              >
                Shop with Discount →
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
